import React from 'react'

import { AdminContextType } from './types'

const AdminContext = React.createContext<AdminContextType>({
  admin: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setAdmin: () => {},
})

export { AdminContext }
